import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiFetch, parseJsonSafe } from '../utils/api';
import { setCustomerToken } from './customerAuth';
import './customer/CustomerPortal.css';

const CustomerLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await apiFetch('/api/branding');
        const data = await parseJsonSafe(res);
        if (active && data && data.company_logo) setLogo(data.company_logo);
      } catch (_e) { /* sin logo */ }
    })();
    return () => { active = false; };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch('/api/v1/software/customer/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data?.message || 'No se pudo completar la operacion, intentalo de nuevo');
      setCustomerToken(data.token || '');
      navigate('/cliente');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="customer-portal">
      <div className="cp-auth-wrapper">
        <div className="cp-auth-brand">
          <div className="cp-auth-brand-content">
            {logo
              ? <div className="cp-auth-logo-box"><img src={logo} alt="Logo" className="cp-auth-logo" /></div>
              : <div className="cp-auth-brand-title">Portal Cliente</div>}
            <div className="cp-auth-brand-subtitle">
              Tus facturas, presupuestos, proyectos y servicios desde un único lugar.
            </div>
          </div>
        </div>
        <div className="cp-auth-form-side">
          <form className="cp-auth-form" onSubmit={onSubmit}>
            <h1>Iniciar sesión</h1>
            <p>Accede a tu portal de cliente</p>

            {error && <div className="cp-alert cp-alert-error" role="alert">{error}</div>}

            <label className="cp-label" htmlFor="cp-login-email">Email</label>
            <input id="cp-login-email" className="cp-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" placeholder="tu@email.com" />

            <label className="cp-label" htmlFor="cp-login-password">Contraseña</label>
            <input id="cp-login-password" className="cp-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" placeholder="Tu contraseña" />

            <button type="submit" className="cp-btn cp-btn-primary" disabled={loading}>
              {loading ? 'Accediendo…' : 'Entrar'}
            </button>

            <div className="cp-auth-links">
              <Link to="/cliente/reset">Recuperar contraseña</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CustomerLoginPage;
